import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes, NoPreloading } from '@angular/router';
import { featurelockGuard } from 'src/app/user/featurelock.guard';
import { environment } from 'src/environments/environment';
import { LinkEntryGuard } from './link/guards/link-entry.guard'; 
import { OnboardingGuard } from './link/guards/onboarding.guard';
import { EnvironmentGuard } from './link/guards/environment.guard';

const defaultRedirect = ((environment as any).appType === 'link') ? '/link-entry' : '/home';

const linkChildRoutes: Routes = [
  { path: '', redirectTo: 'welcome', pathMatch: 'full' },

  {
    path: 'landing',
    canActivate: [LinkEntryGuard],
    loadChildren: () => import('./link/landing/landing.module').then(m => m.LandingPageModule)
  },

  {
    path: 'welcome',
    loadChildren: () => import('./link/welcome/welcome.module').then(m => m.WelcomePageModule)
  },

  {
    path: 'unsupported-device',
    loadChildren: () => import('./link/unsupported-device/unsupported-device.module').then(m => m.UnsupportedDevicePageModule)
  },

  {
    path: 'onboarding',
    loadChildren: () => import('./link/onboarding/onboarding.module').then(m => m.OnboardingModule)  },

  {
  path: 'webcam-setup',
  canActivate: [LinkEntryGuard], // Use APENAS o LinkEntryGuard aqui, não o OnboardingGuard
  loadChildren: () => import('./link/webcam-setup/webcam-setup.module').then(m => m.WebcamSetupPageModule)
},

  {
    path: 'prep-page',
    loadChildren: () => import('./link/prep-page/prep-page.module').then(m => m.PrepPagePageModule)
  },
  {
    path: 'terms',
    loadChildren: () => import('./link/terms/terms.module').then(m => m.TermsPageModule)
  },
  {
    path: 'privacy',
    loadChildren: () => import('./link/privacy/privacy.module').then(m => m.PrivacyPageModule)
  },

  {
    path: 'gaze-calibration',
    loadChildren: () => import('./nav-overlay/gaze-calibration/gaze-calibration.module').then(m => m.GazeCalibrationPageModule)
  },
  
  {
    path: 'spell-talker',
    loadChildren: () => import('./spell-talker/spell-talker.module').then(m => m.SpellTalkerPageModule)
  },

  { path: '**', redirectTo: 'landing' }
];
const fullRoutes: Routes = [
  { path: '', redirectTo: defaultRedirect, pathMatch: 'full' },
  { path: 'gaze-calibration', loadChildren: () => import('./nav-overlay/gaze-calibration/gaze-calibration.module').then(m => m.GazeCalibrationPageModule) },
  { path: 'login-to-unlock-suggestions-popup', loadChildren: () => import('./popups/login-to-unlock-suggestions-popup/login-to-unlock-suggestions-popup.module').then(m => m.LoginToUnlockSuggestionsPopupPageModule) },
  { path: 'consider-subscribing-popup', loadChildren: () => import('./popups/consider-subscribing-popup/consider-subscribing-popup.module').then(m => m.ConsiderSubscribingPopupPageModule) },
  { path: 'quick-guides', loadChildren: () => import('./popups/quick-guides/quick-guides.module').then(m => m.QuickGuidesPageModule) },
  { path: 'log', loadChildren: () => import('./log/log.module').then(m => m.LogPageModule) },
  { path: 'home', loadChildren: () => import('src/app/home/home.module').then(m => m.HomePageModule) },
  { path: 'camera', loadChildren: () => import('src/app/nav-driver/vision-web/camera/camera.module').then(m => m.CameraPageModule) },
  { path: 'wizard-moves', loadChildren: () => import('src/app/nav-processing/mappings/wizard/wizard-moves/wizard-moves.module').then(m => m.WizardMovesPageModule) },
  { path: 'wizard-tests', loadChildren: () => import('src/app/nav-processing/mappings/wizard/wizard-tests/wizard-tests.module').then(m => m.WizardTestsPageModule) },
  { path: 'wizard-form-control', loadChildren: () => import('src/app/nav-processing/mappings/wizard/wizard-form-control/wizard-form-control.module').then(m => m.WizardFormControlPageModule) },
  { path: 'spell-talker', loadChildren: () => import('./spell-talker/spell-talker.module').then(m => m.SpellTalkerPageModule) },
  { path: 'memory-game', loadChildren: () => import('src/app/games/memory-game/memory-game.module').then(m => m.MemoryGamePageModule) },
  { path: 'calculator', loadChildren: () => import('./calculator/calculator.module').then(m => m.CalculatorPageModule) },
  { path: 'login', loadChildren: () => import('./auth/login/login.module').then(m => m.LoginPageModule) },
  { path: 'sign-up', loadChildren: () => import('./auth/sign-up/sign-up.module').then(m => m.SignUpPageModule) },
  { path: 'forgot-password', loadChildren: () => import('./auth/forgot-password/forgot-password.module').then(m => m.ForgotPasswordPageModule) },
  { path: 'verify-email', loadChildren: () => import('./auth/verify-email/verify-email.module').then(m => m.VerifyEmailPageModule) },
  { path: 'instaversia', loadChildren: () => import('./instaversia/instaversia.module').then(m => m.InstaversiaPageModule) },
  { path: 'xilofone-game', loadChildren: () => import('src/app/games/xilofone-game/xilofone-game.module').then( m => m.XilofoneGamePageModule) },
  { path: 'pong-game', loadChildren: () => import('src/app/games/pong-game/pong-game.module').then( m => m.PongGamePageModule) },
  { path: 'environment-control', loadChildren: () => import('./environment-control/environment-control.module').then( m => m.EnvironmentControlPageModule) },
  { path: 'text-presenter', loadChildren: () => import('src/app/document/text-presenter/text-presenter.module').then( m => m.TextPresenterModule) },
  { path: 'document', loadChildren: () => import('./document/document.module').then( m => m.DocumentPageModule), canActivate: [featurelockGuard], },
  { path: 'game-exit-control', loadChildren: () => import('./games/game-exit-control/game-exit-control.module').then( m => m.GameExitControlPageModule) },
  { path: 'eye-calibration', loadChildren: () => import('./nav-processing/eye-calibration/eye-calibration.module').then( m => m.EyeCalibrationPageModule) },
  { path: 'manual-settings', loadChildren: () => import('./manual-settings/manual-settings.module').then( m => m.ManualSettingsPageModule) },
  { path: 'calibration-validation', loadChildren: () => import('./nav-processing/eye-calibration/calibration-validation/calibration-validation.module').then( m => m.CalibrationValidationPageModule) },
  { path: 'completes-calibration', loadChildren: () => import('./nav-processing/eye-calibration/completes-calibration/completes-calibration.module').then( m => m.CompletesCalibrationPageModule) },
  { path: 'calibration-message', loadChildren: () => import('./nav-processing/eye-calibration/calibration-message/calibration-message.module').then( m => m.CalibrationMessagePageModule) },
  { path: 'google-auth', loadChildren: () => import('./youtube/google-auth/google-auth.module').then( m => m.GoogleAuthPageModule) },
  { path: 'google-auth-redirect', loadChildren: () => import('./youtube/google-auth-redirect/google-auth-redirect.module').then( m => m.GoogleAuthRedirectPageModule) },
  { path: 'youtube', loadChildren: () => import('./youtube/youtube.module').then( m => m.YoutubeModule) },
  { path: 'expressia', loadChildren: () => import('./expressia/expressia.module').then( m => m.ExpressiaModule) },
  { path: 'flappy-bird-game', loadChildren: () => import('./games/flappy-bird-game/flappy-bird-game.module').then( m => m.FlappyBirdGamePageModule) },
  { path: 'permissions', loadChildren: () => import('./permissions/permissions.module').then( m => m.PermissionsPageModule) },
  { path: 'manager-user-list', loadChildren: () => import('./manager/manager-user-list/manager-user-list.module').then( m => m.ManagerUserListPageModule) },
  { path: 'manager-operations', loadChildren: () => import('./manager/manager-operations/manager-operations.module').then( m => m.ManagerOperationsPageModule) },
  { path: 'calls', loadChildren: () => import('./calls/calls.module').then( m => m.CallsPageModule) },
  { path: 'pimu-game', loadChildren: () => import('./games/pimu-game/pimu-game.module').then( m => m.PimuGamePageModule) },
  { path: 'iframe', loadChildren: () => import('./games/iframe/iframe.module').then( m => m.IframePageModule) },
  { path: 'start-configuration', loadChildren: () => import('./nav-driver/tracker-configuration/start-configuration/start-configuration.module').then( m => m.StartConfigurationPageModule) },
  { path: 'tracker-setup', loadChildren: () => import('./nav-driver/tracker-configuration/tracker-setup/tracker-setup.module').then( m => m.TrackerSetupPageModule) },
  { path: 'calibration-successful', loadChildren: () => import('./nav-driver/tracker-configuration/calibration-successful/calibration-successful.module').then( m => m.CalibrationSuccessfulPageModule) },
  { path: 'calibration-fail', loadChildren: () => import('./nav-driver/tracker-configuration/calibration-fail/calibration-fail.module').then( m => m.CalibrationFailPageModule) },
  { path: 'reduced-keyboard', loadChildren: () => import('./reduced-keyboard/reduced-keyboard.module').then( m => m.ReducedKeyboardPageModule), canActivate: [featurelockGuard], },
  { path: 'shark-tank', loadChildren: () => import('./shark-tank/shark-tank.module').then( m => m.SharkTankPageModule) },

  
  { path: '**', redirectTo: defaultRedirect },
];

const linkRoutes: Routes = [
  {
    path: 'link',
    canActivate: [EnvironmentGuard], 
    children: linkChildRoutes 
  },
  { path: '', redirectTo: 'link/welcome', pathMatch: 'full' },
  { path: '**', redirectTo: 'link/welcome' }
];

const routes: Routes = ((environment as any).appType === 'link') ? linkRoutes : fullRoutes;
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { 
      useHash: true,
      preloadingStrategy: ((environment as any).appType === 'link') ? NoPreloading : PreloadAllModules 
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }